import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";

// Import the plugin code
import { Cross2Icon } from "@radix-ui/react-icons";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { ActivationEnLigne } from "../../components/Ajouter-intention/ActivationEnLigne";
import { CollectePaiement } from "../../components/Ajouter-intention/CollectePaiement";
import { DemandeIntention } from "../../components/Ajouter-intention/DemandeIntention";
import { Eligibilite } from "../../components/Ajouter-intention/Eligibilite";
import { IndentificationClient } from "../../components/Ajouter-intention/IndentificationClient";
import InstallationUnifiee from "../../components/Ajouter-intention/Installation";
import { LivraisonForm } from "../../components/Ajouter-intention/Livraison";
import { PriseRendezVous } from "../../components/Ajouter-intention/PriseRendezVous";
import { SouscriptionTest } from "../../components/Ajouter-intention/SouscriptionTest";
import { ValidationSurvey } from "../../components/Ajouter-intention/ValidationSurvey";
import { useConfigStore } from "../../store/ConfigStore";
import { LISTE_PARAMETRE_CONFIG } from "../../Utils/constant";
// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
);
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first

const AddIntention = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [postPaidDocuments, setPostPaidDocuments] = useState([]);
  const numeroTicket = localStorage.getItem("numero");
  const location = useLocation();
  const param = useConfigStore();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  useEffect(() => {
    localStorage.removeItem("numero");
  }, [location.pathname]);

  const handleNext = (documents = []) => {
    if (documents && documents.length > 0) {
      setPostPaidDocuments(documents);
    }
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customStep = [
    {
      label: "Verification d'éligilité",
      statut: "",
      element: <Eligibilite handleNext={handleNext} />,
    },
    {
      label: "Enregistrer une intention",
      statut: "ELIGIBLE_EN_ATTENTE_ABONNEMENT",
      element: (
        <DemandeIntention handleNext={handleNext} numero={numeroTicket} />
      ),
    },
    {
      label: "Collecte de paiement",
      statut: "EN_ATTENTE_DE_PAIEMENT",
      element: (
        <CollectePaiement numeroTicket={numeroTicket} handleNext={handleNext} />
      ),
    },
    {
      label: "Livraison de l équipement",
      statut: "EN_ATTENTE_DE_LIVRAISON",
      element: (
        <LivraisonForm numeroTicket={numeroTicket} handleNext={handleNext} />
      ),
    },
    {
      label: "Identification du client",
      statut: "EN_ATTENTE_DE_IDENTIFICATION",
      element: (
        <IndentificationClient
          numeroTicket={numeroTicket}
          handleNext={handleNext}
        />
      ),
    },
    {
      label: "Rendez-vous de survey",
      statut: "EN_ATTENTE_DE_RENDEZ_VOUS",
      element: <PriseRendezVous numeroTicket={numeroTicket} />,
    },
    {
      label: "Validation de vente",
      statut: "EN_ATTENTE_DE_VALIDATION",
      element: <ActivationEnLigne numeroTicket={numeroTicket} />,
    },
    {
      label: "Survey",
      statut: "EN_ATTENTE_DE_SURVEY",
      element: <ValidationSurvey numeroTicket={numeroTicket} />,
    },
    {
      label: "Installation",
      statut: "EN_ATTENTE_INSTALLATION",
      element: <InstallationUnifiee numeroTicket={numeroTicket} />,
    },
    {
      label: "Test de connectivité",
      statut: "EN_ATTENTE_DE_TEST",
      element: <SouscriptionTest numeroTicket={numeroTicket} />,
    },
  ];

  const newStep = [];
  if (
    param?.data?.VALIDATION_SP === "true" ||
    param?.data?.VALIDATION_SP === null
  ) {
    customStep.map((step) => newStep.push(step));
  } else {
    customStep
      .filter((e) => e.statut !== "EN_ATTENTE_DE_VALIDATION")
      .map((step) => newStep.push(step));
  }

  return (
    <div className="relative pb-32 mb-20">
      <dialog id="delete_batiment" className="modal">
        <div className="modal-box max-w-md rounded-lg">
          <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
          <p className="pt-2 text-black font-medium">
            Voulez vous des modifications en cours ?
          </p>
          <div className="modal-action">
            <form
              method="dialog"
              className="w-full flex items-center justify-end gap-x-4"
            ></form>
          </div>
        </div>
      </dialog>
      <button
        onClick={() => {
          window.history.back();
          localStorage.removeItem("numeroTicket");
        }}
        className="lg:hidden md:hidden xl:hidden bg-red-50 text-red-700 w-10 h-10 flex items-center justify-center rounded-full"
      >
        <Cross2Icon className="w-6 h-6" />
      </button>
      <h1 className="font-mtn px-8 lg:text-3xl md:text-3xl xl:text-3xl text-2xl font-extrabold text-black">
        Processus d'acquisition de la FTTH
      </h1>
      <button
        onClick={() => {
          window.history.back();
          localStorage.removeItem("numeroTicket");
        }}
        className="absolute top-0 right-8 hidden lg:flex md:flex xl:flex btn-circle btn btn-sm  items-center justify-center btn-error text-white hover:text-black"
      >
        <Cross2Icon />
      </button>
      <div className="py-2 h-fit flex xl:flex-row lg:flex-row md:flex-row flex-col gap-8 lg:px-8 w-full mx-auto  ">
        <div className="md:w-[20%]  lg:w-[20%] xl:w-[20%] lg:h-[77.5vh] md:h-[77.5vh] xl:lg:h-[77.5vh] h- w-full flex flex-col justify-between pb-1">
          <div className="hidden md:block lg:block xl:block">
            <ul className="steps steps-vertical">
              {newStep.map((step, index) => (
                <li
                  data-content={`${index < activeStep ? "✓" : index + 1} `}
                  className={`step ${
                    index < activeStep ? "step-warning " : ""
                  }`}
                >
                  <p className="text-xs">{step.label}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="px-6 pb-8 rounded-lg flex flex-col w-full lg:w-[85%]">
          {newStep[activeStep] && newStep[activeStep].element}
        </div>
      </div>
    </div>
  );
};

export default AddIntention;
